import { DropdownItemProps } from "semantic-ui-react";
import { map } from "lodash";
import { ReviewStatus, SourceType } from "@/interfaces";

const reviewLabels = {
  [ReviewStatus.REVIEWED]: "Reviewed",
  [ReviewStatus.REQUEST_CHANGES]: "Request Change",
  [ReviewStatus.COMPLETED]: "Completed",
  [ReviewStatus.NULL]: "Needs Review",
  [ReviewStatus.CHANGES_SUBMITTED]: "Changes Submitted",
};

export const reviewStatusOptions: DropdownItemProps[] = map(
  [
    ReviewStatus.REVIEWED,
    ReviewStatus.REQUEST_CHANGES,
    ReviewStatus.COMPLETED,
    ReviewStatus.NULL,
    ReviewStatus.CHANGES_SUBMITTED,
  ],
  rStatus => ({
    key: rStatus,
    text: reviewLabels[rStatus],
    value: rStatus,
  })
);

export const sourceTypeLabels = {
  [SourceType.CAMPAIGN]: "Campaign",
  [SourceType.CONTENT_PAGE]: "Video Page",
  [SourceType.VIDEO_PROJECT]: "Video Project",
  [SourceType.PROMPT]: "Prompt",
  [SourceType.POST]: "Post",
};

export const sourceTypeOptions: DropdownItemProps[] = map(
  [SourceType.CAMPAIGN, SourceType.PROMPT, SourceType.VIDEO_PROJECT, SourceType.CONTENT_PAGE, SourceType.POST],
  type => ({
    key: type,
    text: sourceTypeLabels[type],
    value: type,
  })
);

export const mediaTypeOptions: DropdownItemProps[] = [
  { key: "VIDEO", value: "VIDEO", text: "Video" },
  { key: "IMAGE", value: "IMAGE", text: "Image" },
];
